import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@mui/material/styles';
import { FlexBox, Typography, useMediaQuery } from 'ml-rubiks-styleguide';
import { injectTSDI } from 'ml-webclient-common/src/tsdi';
import { I18nStore } from '../../core/i18n';
function formatExpiry(expiry) {
    if (!expiry) {
        return '';
    }
    const month = expiry.monthValue;
    const { year } = expiry;
    if (month && year) {
        // Format: MM/YY
        const monthStr = String(month).padStart(2, '0');
        const yearStr = String(year).slice(-2);
        return `${monthStr}/${yearStr}`;
    }
    return '';
}
function maskCardNumber(cardNumber) {
    // Show only last 4 digits
    const last4 = cardNumber.slice(-4);
    return `************${last4}`;
}
export function CreditCardDetails({ creditCard }) {
    const i18n = injectTSDI(I18nStore);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const rows = [
        {
            label: i18n.__('ffl.update.payment.method.credit.card.number'),
            value: maskCardNumber(creditCard.cardNumber)
        },
        {
            label: i18n.__('ffl.update.payment.method.credit.card.expiration'),
            value: formatExpiry(creditCard.expiry)
        },
        {
            label: i18n.__('ffl.update.payment.method.credit.card.holder'),
            value: creditCard.cardHolder
        }
    ].filter((row) => row.value);
    if (isMobile) {
        return (_jsx(FlexBox, { stack: true, sx: { mb: 2 }, children: rows.map((row) => (_jsxs(FlexBox, { stack: true, sx: { mb: 1.5 }, children: [_jsx(Typography, { variant: "body1", color: "text.secondary", children: row.label }), _jsx(Typography, { variant: "body1", fontWeight: 600, children: row.value })] }, row.label))) }));
    }
    return (_jsxs(FlexBox, { gap: 4, sx: { mb: 2 }, children: [_jsx(FlexBox, { stack: true, children: rows.map((row) => (_jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 0.5 }, children: row.label }, row.label))) }), _jsx(FlexBox, { stack: true, children: rows.map((row) => (_jsx(Typography, { variant: "body1", fontWeight: 600, sx: { mb: 0.5 }, children: row.value }, row.label))) })] }));
}
